import angular from 'angular';

import MODULE_NAME from '../../app'

import range from './listRangeFilter'
import defaultValue from './defaultValue'


angular.module(MODULE_NAME)
.filter('range', range)
.filter('defaultValue', defaultValue)



// WEBPACK FOOTER //
// ./src/app/scripts/helpers/index.js